import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyImplantStocks } from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import { getEntities as getPharmacyImplantBillItems } from 'app/entities/pharmacy-implant-bill-item/pharmacy-implant-bill-item.reducer';
import { getEntities as getPharmacyRefundBills } from 'app/entities/pharmacy-refund-bill/pharmacy-refund-bill.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { getEntities as getPharmacyImplantReturnBillItems } from 'app/entities/pharmacy-implant-return-bill-item/pharmacy-implant-return-bill-item.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-implant-refund-bill-item.reducer';

export const PharmacyImplantRefundBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyImplantStocks = useAppSelector(state => state.pharmacyImplantStock.entities);
  const pharmacyImplantBillItems = useAppSelector(state => state.pharmacyImplantBillItem.entities);
  const pharmacyRefundBills = useAppSelector(state => state.pharmacyRefundBill.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyImplantReturnBillItems = useAppSelector(state => state.pharmacyImplantReturnBillItem.entities);
  const pharmacyImplantRefundBillItemEntity = useAppSelector(state => state.pharmacyImplantRefundBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyImplantRefundBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyImplantRefundBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyImplantRefundBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-implant-refund-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyImplantStocks({}));
    dispatch(getPharmacyImplantBillItems({}));
    dispatch(getPharmacyRefundBills({}));
    dispatch(getPharmacyBills({}));
    dispatch(getPharmacyReturnBills({}));
    dispatch(getPharmacyImplantReturnBillItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.refundPaid !== undefined && typeof values.refundPaid !== 'number') {
      values.refundPaid = Number(values.refundPaid);
    }
    if (values.refundQty !== undefined && typeof values.refundQty !== 'number') {
      values.refundQty = Number(values.refundQty);
    }
    if (values.soldQty !== undefined && typeof values.soldQty !== 'number') {
      values.soldQty = Number(values.soldQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }

    const entity = {
      ...pharmacyImplantRefundBillItemEntity,
      ...values,
      pharmacyStock: pharmacyImplantStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      saleBillItem: pharmacyImplantBillItems.find(it => it.id.toString() === values.saleBillItem?.toString()),
      refundBill: pharmacyRefundBills.find(it => it.id.toString() === values.refundBill?.toString()),
      saleBill: pharmacyBills.find(it => it.id.toString() === values.saleBill?.toString()),
      returnBill: pharmacyReturnBills.find(it => it.id.toString() === values.returnBill?.toString()),
      returnItem: pharmacyImplantReturnBillItems.find(it => it.id.toString() === values.returnItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyImplantRefundBillItemEntity,
          pharmacyStock: pharmacyImplantRefundBillItemEntity?.pharmacyStock?.id,
          saleBillItem: pharmacyImplantRefundBillItemEntity?.saleBillItem?.id,
          refundBill: pharmacyImplantRefundBillItemEntity?.refundBill?.id,
          saleBill: pharmacyImplantRefundBillItemEntity?.saleBill?.id,
          returnBill: pharmacyImplantRefundBillItemEntity?.returnBill?.id,
          returnItem: pharmacyImplantRefundBillItemEntity?.returnItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyImplantRefundBillItem.home.createOrEditLabel"
            data-cy="PharmacyImplantRefundBillItemCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.home.createOrEditLabel">
              Create or edit a PharmacyImplantRefundBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-implant-refund-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.chargedMrp')}
                id="pharmacy-implant-refund-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.refundPaid')}
                id="pharmacy-implant-refund-bill-item-refundPaid"
                name="refundPaid"
                data-cy="refundPaid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.refundQty')}
                id="pharmacy-implant-refund-bill-item-refundQty"
                name="refundQty"
                data-cy="refundQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.soldQty')}
                id="pharmacy-implant-refund-bill-item-soldQty"
                name="soldQty"
                data-cy="soldQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.manufacDate')}
                id="pharmacy-implant-refund-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.expDate')}
                id="pharmacy-implant-refund-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.active')}
                id="pharmacy-implant-refund-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.cursor')}
                id="pharmacy-implant-refund-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.timestampentry')}
                id="pharmacy-implant-refund-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.microSec')}
                id="pharmacy-implant-refund-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.lastupdated')}
                id="pharmacy-implant-refund-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantStocks
                  ? pharmacyImplantStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-saleBillItem"
                name="saleBillItem"
                data-cy="saleBillItem"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.saleBillItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantBillItems
                  ? pharmacyImplantBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-refundBill"
                name="refundBill"
                data-cy="refundBill"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.refundBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundBills
                  ? pharmacyRefundBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-saleBill"
                name="saleBill"
                data-cy="saleBill"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.saleBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-returnBill"
                name="returnBill"
                data-cy="returnBill"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.returnBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-refund-bill-item-returnItem"
                name="returnItem"
                data-cy="returnItem"
                label={translate('tinyMedicRestApp.pharmacyImplantRefundBillItem.returnItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantReturnBillItems
                  ? pharmacyImplantReturnBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-implant-refund-bill-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyImplantRefundBillItemUpdate;
